import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/sysInterface/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/sysInterface/get',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/sysInterface/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/sysInterface/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/sysInterface/update',
    method: 'post',
    data: data
  });
}